module.exports = __webpack_public_path__ + "static/media/logo-sebrae.f0dfdbd1.svg";